import { create } from "zustand";
import { RydPlayerSession } from "../audio/AudioController";
import { RydBookmark } from "../model/bookmark";
import { Loop } from "tone";
import { LoopPlaybackSetup } from "../model/loop";

export type PlaybackConfStore = {
    isMetronomeMuted: boolean;
    setMuteMetronome: (mute: boolean) => void;
    isPlaying: boolean;
    setIsPlaying: (playing: boolean) => void;
    isPaused: boolean;
    setIsPaused: (paused: boolean) => void;
    isRecording: boolean;
    setIsRecording: (recording: boolean) => void;
    loopPlaybackSetup: LoopPlaybackSetup;
    setLoopPlaybackSetup: (setup: LoopPlaybackSetup) => void;
    playerSession?: RydPlayerSession
    setPlayerSession: (session?: RydPlayerSession) => void;
}

export const playbackConfStore = create<PlaybackConfStore>((set) => ({
    isMetronomeMuted: false,
    setMuteMetronome: (mute: boolean) => set({ isMetronomeMuted: mute }),
    isPlaying: false,
    setIsPlaying: (playing: boolean) => set({ isPlaying: playing }),
    isPaused: false,
    setIsPaused: (paused: boolean) => set({ isPaused: paused }),
    isRecording: false,
    setIsRecording: (recording: boolean) => set({ isRecording: recording }),
    loopPlaybackSetup: {
        isLooping: false
    },
    setLoopPlaybackSetup: (setup) => set({ loopPlaybackSetup: setup }),
    playerSession: undefined,
    setPlayerSession: (session?: RydPlayerSession) => set({ playerSession: session }),
}));

export const usePlaybackConfStore = () => {
    return playbackConfStore((state) => ({
        isMetronomeMuted: state.isMetronomeMuted,
        setMuteMetronome: state.setMuteMetronome,
        isPlaying: state.isPlaying,
        setIsPlaying: state.setIsPlaying,
        isPaused: state.isPaused,
        setIsPaused: state.setIsPaused,
        isRecording: state.isRecording,
        setIsRecording: state.setIsRecording,
        loopPlaybackSetup: state.loopPlaybackSetup,
        setLoopPlaybackSetup: state.setLoopPlaybackSetup,
        playerSession: state.playerSession,
        setPlayerSession: state.setPlayerSession,
    }));
}

export const useIsMetronomeMuted = () => playbackConfStore((state) => state.isMetronomeMuted);
export const useSetMuteMetronome = () => playbackConfStore((state) => state.setMuteMetronome);
export const isMetronomeMuted = () => playbackConfStore.getState().isMetronomeMuted;

export const useIsPlaying = () => playbackConfStore((state) => state.isPlaying);
export const useSetIsPlaying = () => playbackConfStore((state) => state.setIsPlaying);

export const useIsPaused = () => playbackConfStore((state) => state.isPaused);
export const useSetIsPaused = () => playbackConfStore((state) => state.setIsPaused);

export const useIsRecording = () => playbackConfStore((state) => state.isRecording);
export const useSetIsRecording = () => playbackConfStore((state) => state.setIsRecording);

export const useLoopPlaybackSetup = () => playbackConfStore((state) => state.loopPlaybackSetup);
export const useSetLoopPlaybackSetup = () => playbackConfStore((state) => state.setLoopPlaybackSetup);

export const usePlayerSession = () => playbackConfStore((state) => state.playerSession);
export const useSetPlayerSession = () => playbackConfStore((state) => state.setPlayerSession);